/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Edit_LabelInputs */

const en_landing_studio_edit_label = /** @type {(inputs: Landing_Studio_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the change`)
};

const zh_landing_studio_edit_label = /** @type {(inputs: Landing_Studio_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述要做的修改`)
};

/**
* | output |
* | --- |
* | "Describe the change" |
*
* @param {Landing_Studio_Edit_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_edit_label = /** @type {((inputs?: Landing_Studio_Edit_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Edit_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_edit_label(inputs)
	return zh_landing_studio_edit_label(inputs)
});
export { landing_studio_edit_label as "landing.studio.edit_label" }